import { ListItem, List as MUIList } from '@mui/material';

import RichText from '@/common/components/RichText/RichText';
import { RichTextNode } from '@/common/components/RichText/RichTextService';
import { listStyles, richTextStyles } from '@/common/components/RichText/components/List/List.styled';

interface ListProps {
  node: RichTextNode;
  centered?: boolean;
}

export default function List({ node, centered }: ListProps) {
  if (!node.content || node.content.length === 0) return null;

  const ListTag = node.nodeType === 'unordered-list' ? 'ul' : 'ol';

  return (
    <MUIList
      component={ListTag}
      sx={listStyles(centered ?? false, ListTag)}
    >
      {node.content.map((item, index) => (
        <ListItem key={index}>
          <RichText sx={richTextStyles} content={item.content || []} />
        </ListItem>
      ))}
    </MUIList>
  );
}
